import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import type { DashboardWidgetViewFragment } from "@ankaadia/graphql";
import { DashboardWidgetLogoSize } from "@ankaadia/graphql";
import { Card } from "primeng/card";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";

/**
 * Branding strip an organization shows at the top of the dashboard. Purely presentational, also used as the live
 * preview of the settings page.
 */
@Component({
  selector: "new-ui-dashboard-branding-widget",
  templateUrl: "./new-ui-dashboard-branding-widget.component.html",
  imports: [Card, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiDashboardBrandingWidgetComponent {
  readonly widget = input.required<DashboardWidgetViewFragment>();

  protected readonly isLargeLogo = computed(() => this.widget().logoSize === DashboardWidgetLogoSize.Large);
}
